module.exports = __webpack_public_path__ + "static/media/workbrook_logo.b73e954c.svg";